export const TAGS_WATCHING_LIMIT = 9;
export const TAGS_TRENDING_LIMIT = 6;
